export default __webpack_public_path__ + "static/media/m4a.8f543844.svg";